import { getNoValue } from "../helpers.js";
/**
 * Validates a dependent field.
 *
 * @param parentField The dependent field settings.
 * @param dependencySettings The custom settings for the dependent field.
 * @param parentValue The value of the field.
 * @returns If the field is valid.
 * @throws Error If the field depends on an object.
 */
export function isRequired(parentField, dependencySettings, parentValue) {
    if (typeof parentValue === "object") {
        throw new Error("Invalid dependsOn configuration. A field cannot depend on an object.");
    }
    const parentNoValue = getNoValue(parentField);
    if (typeof dependencySettings === "string") {
        return !!(parentValue && parentValue !== parentNoValue);
    }
    if (Array.isArray(dependencySettings.value)) {
        return !!(parentValue && dependencySettings.value.includes(parentValue));
    }
    return !!(parentValue && parentValue === dependencySettings.value);
}
//# sourceMappingURL=isRequired.js.map